webpackJsonp([152424973348419],{

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTypist = __webpack_require__(37);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	var _reactBurgerMenu = __webpack_require__(35);
	
	var _reactHelmet = __webpack_require__(36);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _footer = __webpack_require__(27);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _icon = __webpack_require__(28);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _menu = __webpack_require__(41);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _phone = __webpack_require__(43);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _tusk = __webpack_require__(44);
	
	var _tusk2 = _interopRequireDefault(_tusk);
	
	var _twitter = __webpack_require__(45);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _heart = __webpack_require__(38);
	
	var _heart2 = _interopRequireDefault(_heart);
	
	var _like = __webpack_require__(40);
	
	var _like2 = _interopRequireDefault(_like);
	
	var _laugh = __webpack_require__(39);
	
	var _laugh2 = _interopRequireDefault(_laugh);
	
	var _message = __webpack_require__(42);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _airplane = __webpack_require__(61);
	
	var _airplane2 = _interopRequireDefault(_airplane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var terms = function (_Component) {
	  _inherits(terms, _Component);
	
	  function terms(props) {
	    _classCallCheck(this, terms);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.toggleMenu = function () {
	      _this.setState({ menuOpen: !_this.state.menuOpen });
	    };
	
	    _this.state = {
	      menuOpen: false,
	      isOpen: false,
	      youtubeId: null
	    };
	    return _this;
	  }
	
	  // This keeps your state in sync with the opening/closing of the menu
	  // via the default means, e.g. clicking the X, pressing the ESC key etc.
	
	
	  terms.prototype.handleStateChange = function handleStateChange(state) {
	    this.setState({ menuOpen: state.isOpen });
	  };
	
	  // This can be used to close the menu, e.g. when a user clicks a menu item
	
	
	  terms.prototype.closeMenu = function closeMenu() {
	    this.setState({ menuOpen: false });
	  };
	
	  // This can be used to toggle the menu, e.g. when using a custom icon
	  // Tip: You probably want to hide either/both default icons if using a custom icon
	  // See https://github.com/negomi/react-burger-menu#custom-icons
	
	
	  terms.prototype.render = function render() {
	    var _this2 = this;
	
	    var Signature = _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 199 143', xmlns: 'http://www.w3.org/2000/svg' },
	      _react2.default.createElement(
	        'g',
	        { id: 'Page-1', fill: 'none', fillRule: 'evenodd', stroke: '#000' },
	        _react2.default.createElement('path', { d: 'M49.1416016,31.1152344 C75.2822266,8.24153646 94.8652344,-1.73730469 107.890625,1.17871094 C127.428711,5.55273438 107.850586,23.5957031 89.9755859,41.9179687 C72.1005859,60.2402344 48.3701172,84.2607422 61.9423828,84.2607422 C75.5146484,84.2607422 190.460938,39.0410156 174.953125,18.2646484 C159.445313,-2.51171875 97.7431641,14.2675781 89.9755859,20.3095703 C82.2080078,26.3515625 59.3632813,35.0810547 94.2402344,61.4013672 C129.117188,87.7216797 146.483398,106.082031 143.764648,119.708008 C141.045898,133.333984 124.748047,142.709961 102.599609,141.464844 C80.4511719,140.219727 63.8066406,137.329102 63.8066406,119.708008 C63.8066406,102.086914 98.2822266,92.1962891 149.499023,79.2382813 C200.71582,66.2802734 212.223633,59.1152344 177.994141,54.3701172 C143.764648,49.625 68.6064453,41.9443359 27.2304687,45.6464844 C-0.353515625,48.1145833 -6.02669271,50.2369792 10.2109375,52.0136719',
	          id: '1-stroke' }),
	        _react2.default.createElement('path', { d: 'M65.0527344,50.0185547 C65.811849,72.8219401 67.96875,89.7386068 71.5234375,100.768555',
	          id: '2-stroke' })
	      )
	    );
	    return _react2.default.createElement(
	      'div',
	      { id: 'outer-container' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Terms of Use | TUSK, Inc.'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'We draw on decades of corporate, non-profit, and political victories to empower a new generation of innovators with the hard-won context of yesterday and the tools to shape tomorrow.' })
	      ),
	      _react2.default.createElement(
	        _reactBurgerMenu.slide,
	        {
	          pageWrapId: 'page-wrap',
	          width: '75vw',
	          isOpen: this.state.menuOpen,
	          customBurgerIcon: false,
	          onStateChange: function onStateChange(state) {
	            return _this2.handleStateChange(state);
	          },
	          bodyClassName: 'menu-open'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'container py-4' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'mt-4 mb-4' },
	            'New norms. New ideas. New TUSK.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Welcome to the new normal: an evolving idea of what it means to be an influencer, a global citizen, a changemaker. \u201CPolitics\u201D are no longer confined to campaigns. The new social order bends and breaks with every\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'icon-animation' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _twitter2.default, height: 24 })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _heart2.default, height: 15, fill: '#e95b4b' })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _like2.default, height: 24, fill: '#238af7' })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _laugh2.default, height: 15 })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _message2.default, height: 15 })
	              )
	            ),
	            '\xA0as disruption reigns supreme. From the classroom to the boardroom\u2014and everywhere in between\u2014agility and insurgency run the show. Get ready.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Even in this unprecedented era, success relies on experience. TUSK draws on decades of corporate, non-profit, and political victories to empower a new generation of innovators with the hard-won context of yesterday and the tools to shape tomorrow.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The rules have changed. So have we. Labels mean nothing in this new landscape: If you\u2019re trying to do something extraordinary, we want to help.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'So. Let\u2019s get started.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ron' },
	            Signature,
	            _react2.default.createElement(
	              'div',
	              { className: 'h6 mb-0 mt-3' },
	              '- Ron Steslow'
	            ),
	            _react2.default.createElement(
	              'i',
	              null,
	              'President, TUSK INC'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contact', role: 'button', tabIndex: 0, className: 'mt-5 btn btn-secondary btn-block' },
	                'Let\'s Talk'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'page-wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid d-md-block d-none' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pt-3 pb-5' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary', onClick: function onClick() {
	                  return _this2.toggleMenu();
	                } },
	              _react2.default.createElement(_icon2.default, { icon: _menu2.default, width: 24, height: 30, fill: '#fff' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-5 logo-area' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary d-inline-block d-md-none', onClick: function onClick() {
	                    return _this2.toggleMenu();
	                  } },
	                _react2.default.createElement(_icon2.default, { icon: _menu2.default, width: 24, height: 30, fill: '#fff' })
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/', className: 'logo', href: '#' },
	                _react2.default.createElement(_icon2.default, { icon: _tusk2.default, height: 70, fill: '#000' })
	              ),
	              _react2.default.createElement(
	                'h2',
	                { className: 'tagline' },
	                'Footnotes to Frontrunners.'
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contact', className: 'd-inline-block d-md-none btn btn-primary' },
	                _react2.default.createElement(_icon2.default, { icon: _airplane2.default, width: 24, height: 30, fill: '#fff' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-none d-md-inline-block' },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/', role: 'button', tabIndex: 0, className: 'd-none d-md-inline-block mt-md-4 btn btn-lg btn-secondary mr-2' },
	                  'Home'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/contact', role: 'button', tabIndex: 0, className: 'd-none d-md-inline-block mt-md-4 btn btn-lg btn-secondary' },
	                  'Let\'s Talk'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-7 py-3 ml-auto' },
	              _react2.default.createElement(
	                _reactTypist2.default,
	                { className: 'h1 mb-5 ml-0 ml-md-4' },
	                'Terms of use'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'px-md-4 pl-0' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'USER AGREEMENT'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'The following are terms of a legal agreement (the "Agreement") between you and Tusk Digital.com ("Tusk Digital", "we", or "us") that sets forth the terms and conditions for your use of this web site (the "Site"). The Site is owned and operated by Tusk Digital.  This Site is being provided to you expressly subject to this Agreement. By accessing, browsing and/or using this site ("Site"), you acknowledge that you have read, understood, and agree to be bound by the terms of this Agreement and to comply with all applicable laws and regulations. The terms and conditions of this Agreement form an essential basis of our bargain. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'LIMITATIONS OF USE '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'The copyright in all material on this Site, including without limitation the text, data, articles, design, source code, software, photos, images and other information (collectively the "Content"), is held by Tusk Digital or by the original creator of the material and is protected by U.S. and International copyright laws and treaties. You agree that the Content may not be copied, reproduced, distributed, republished, displayed, posted or transmitted in any form or by any means, including, but not limited to, electronic, mechanical, photocopying, recording, or otherwise, without the express prior written consent of Tusk Digital. You acknowledge that the Content is and shall remain the property of Tusk Digital. You may not modify, participate in the sale or transfer of, or create derivative works based on any Content, in whole or in part. The use of the Content on any other Site, including by linking or framing, or in any networked computer environment for any purpose, is prohibited without Tusk Digital\'s prior written approval. You also may not, without Tusk Digital\'s express written permission, "mirror" any material contained on this Site on any other server. Any unauthorized use of any Content on this Site may violate copyright laws, trademark laws, the laws of privacy and publicity, and communications statutes and regulations. You agree to use the Content and Site only for lawful purposes. You are prohibited from any use of the Content or Site that would constitute a violation of any applicable law, regulation, rule or ordinance of any nationality, state, or locality or of any international law or treaty, or that could give rise to any civil or criminal liability. Any unauthorized use of the Site, including but not limited to unauthorized entry into Tusk Digital\'s systems, misuse of passwords, or misuse of any information posted on the Site is strictly prohibited. Tusk Digital makes no claims concerning whether the Content may be downloaded or is appropriate for use outside of the United States. If you access this Site from outside of the United States, you are solely responsible for ensuring compliance with the laws of your specific jurisdiction. Your eligibility for particular products or services is subject to final determination by Tusk Digital. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'TRADEMARKS '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Tusk Digital (including the Tusk Digital logo), Tusk Digital.com, and all related logos (collectively the "Tusk Digital Trademarks") are trademarks or service marks of Tusk Digital. Other company, product, and service names and logos used and displayed on this Site may be trademarks or service marks owned by Tusk Digital or others. Nothing on this Site should be construed as granting, by implication, estoppel, or otherwise, any license or right to use any of the Tusk Digital trademarks displayed on this Site, without our prior written permission in each instance. You may not use, copy, display, distribute, modify or reproduce any of the trademarks found on the Site unless in accordance with written authorization by us. We prohibit use of any of the Tusk Digital trademarks as part of a link to or from any site unless establishment of such a link is approved in writing by us in advance. Any questions concerning any Tusk Digital Trademarks, or whether any mark or logo is a Tusk Digital Trademark, should be referred to Tusk Digital. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'DISCLAIMER OF WARRANTIES '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'NONE OF Tusk Digital, ANY OF ITS AFFILIATES, PROVIDERS OR THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, INDEPENDENT CONTRACTORS OR LICENSORS (COLLECTIVELY THE "Tusk Digital PARTIES") GUARANTEES THE ACCURACY, ADEQUACY, TIMELINESS, RELIABILITY, COMPLETENESS, OR USEFULNESS OF ANY OF THE CONTENT AND Tusk Digital DISCLAIMS LIABILITY FOR ERRORS OR OMISSIONS IN THE CONTENT. THIS SITE AND ALL OF THE CONTENT IS PROVIDED "AS IS" AND "AS AVAILABLE," WITHOUT ANY WARRANTY, EITHER EXPRESS OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT OR TITLE. ADDITIONALLY, THERE ARE NO WARRANTIES AS TO THE RESULTS OF YOUR USE OF THE CONTENT. Tusk Digital PARTIES DO NOT WARRANT THAT THE SITE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. THIS DOES NOT AFFECT THOSE WARRANTIES WHICH ARE INCAPABLE OF EXCLUSION, RESTRICTION OR MODIFICATION UNDER THE LAWS APPLICABLE TO THIS AGREEMENT. Tusk Digital MAY DISCONTINUE OR MAKE CHANGES IN THE CONTENT AND SITE AT ANY TIME WITHOUT PRIOR NOTICE TO YOU AND WITHOUT ANY LIABILITY TO YOU. ANY DATED INFORMATION IS PUBLISHED AS OF ITS DATE ONLY, AND Tusk Digital PARTIES DO NOT UNDERTAKE ANY OBLIGATION OR RESPONSIBILITY TO UPDATE OR AMEND ANY SUCH INFORMATION. Tusk Digital RESERVES THE RIGHT TO TERMINATE ANY OR ALL SITE OFFERINGS OR TRANSMISSIONS WITHOUT PRIOR NOTICE TO YOU. THIS SITE COULD CONTAIN TECHNICAL INACCURACIES OR TYOPOGRAPHICAL ERRORS. USE OF THIS SITE IS AT YOUR OWN RISK. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'LIMITATION OF LIABILITY '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'UNDER NO CIRCUMSTANCES WILL Tusk Digital PARTIES BE LIABLE FOR ANY DAMAGES INCLUDING GENERAL, SPECIAL, DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR ANY OTHER DAMAGES (INCLUDING, WITHOUT LIMITATION, LOST PROFITS OR BUSINESS INTERRUPTION) OF ANY KIND WHETHER IN AN ACTION IN CONTRACT OR NEGLIGENCE ARISING OR RELATING IN ANY WAY TO THE USE OR INABILITY TO USE BY ANY PARTY OF THE CONTENT, THE SITE OR ANY THIRD-PARTY SITE TO WHICH THIS SITE IS LINKED, OR IN CONNECTION WITH ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION, DEFECT, DELAY IN OPERATION OR TRANSMISSION, COMPUTER VIRUS OR LINE OR SYSTEM FAILURE, EVEN IF Tusk Digital PARTIES, OR REPRESENTATIVES THEREOF, ARE ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, LOSSES OR EXPENSES. Tusk Digital IS NOT LIABLE FOR ANY DEFAMATORY, OFFENSIVE OR ILLEGAL CONDUCT OF ANY USER. YOUR SOLE REMEDY FOR DISSATISFACTION WITH THIS SITE IS TO STOP USING THE SITE. IF YOUR USE OF MATERIALS FROM THIS SITE RESULTS IN THE NEED FOR SERVICING, REPAIR OR CORRECTION OF EQUIPMENT OR DATA, YOU ASSUME ANY COSTS THEREOF. IF THE FOREGOING LIMITATION IS FOUND TO BE INVALID, YOU AGREE THAT Tusk Digital PARTIES\' TOTAL LIABILITY FOR ALL DAMAGES, LOSSES, OR CAUSES OF ACTION OF ANY KIND OR NATURE SHALL BE LIMITED TO THE GREATEST EXTENT PERMITTED BY APPLICABLE LAW. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'INDEMNIFICATION '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'You agree to indemnify and hold harmless Tusk Digital Parties from and against any and all claims, losses, expenses, demands or liabilities, including attorneys\' fees and costs, incurred by the Tusk Digital Parties in connection with any claim by a third party (including any intellectual property claim) arising out of (i) materials and content you submit to, post to or transmit through the Site, or (ii) your use of the Site in violation of this Agreement or in violation of any applicable law. You further agree that you will cooperate fully in the defense of any such claims. Tusk Digital Parties reserve the right, at their own expense, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you, and you shall not in any event settle any such claim or matter without the written consent of Tusk Digital. You further agree to indemnify and hold harmless Tusk Digital Parties from any claim arising from a third party\'s use of information or materials of any kind that you post to the Site. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'MONITORING OF THE SITE '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Tusk Digital has no obligation to monitor the Site; however, you acknowledge and agree that Tusk Digital has the right to monitor the Site electronically from time to time and to disclose any information as necessary or appropriate to satisfy any law, regulation or other governmental request, to operate the Site, or to protect itself or other users of the Site. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'SUBMISSIONS TO THE SITE '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'All remarks, discussions, ideas, concepts, know-how, techniques, graphics or other submissions communicated to Tusk Digital through this Site (collectively, "Submissions") will be deemed and remain the property of Tusk Digital, and Tusk Digital is entitled to use any Submission for any purpose, without restriction or compensation to the individual who has provided the Submission. Tusk Digital shall not be subject to any obligations of confidentiality regarding Submissions except as expressly agreed by Tusk Digital or as otherwise required by applicable law. Nothing herein contained shall be construed as limiting Tusk Digital\'s responsibilities and obligations under its Privacy Policy. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'USE OF PERSONALLY IDENTIFIABLE INFORMATION '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Tusk Digital\'s practices and policies with respect to the collection and use of personally identifiable information are governed by Tusk Digital\'s Privacy Policy. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'AVAILABILITY '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'This Site is not intended for distribution to, or use by, any person or entity in any jurisdiction or country where such distribution or use would be contrary to applicable law or regulation. By offering this site and Content no distribution or solicitation is made by Tusk Digital to any person to use the Site or Content in jurisdictions where the provision of the site and/or content is prohibited by law. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'TERMINATION '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'This Agreement is effective until terminated by Tusk Digital. Tusk Digital may terminate this Agreement at any time without notice, or suspend or terminate your access and use of the Site at any time, with or without cause, in Tusk Digital\'s absolute discretion and without notice. The following provisions of this Agreement shall survive termination of your use or access to the Site: the sections concerning Indemnification, Disclaimer of Warranties, Limitation of Liability, Waiver, Applicable Law and Dispute Resolution, and General Provisions, and any other provision that by its terms survives termination of your use or access to the Site. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'WAIVER '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Failure by Tusk Digital to enforce any of its rights under this Agreement shall not be construed as a waiver of those rights or any other rights in any way whatsoever. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'APPLICABLE LAW AND DISPUTE RESOLUTION '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'This Agreement and all other aspects of your use of the Site shall be governed by and construed in accordance with the laws of the United States and, to the extent applicable, to the laws of the State of Texas, without regard to its conflict of laws rules. You agree that you will notify Tusk Digital in writing of any claim or dispute concerning or relating to the Site and the information or services provided through it, and give Tusk Digital a reasonable period of time to address it BEFORE bringing any legal action, either individually, as a class member or representative, or as a private attorney general, against Tusk Digital. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'OTHER AGREEMENTS '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'This Agreement shall be subject to any other agreements you have entered into with Tusk Digital. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'ADDITIONAL TERMS '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Certain sections or pages on the Site may contain separate terms and conditions of use, which are in addition to the terms and conditions of this Agreement. In the event of a conflict, the additional terms and conditions will govern for those sections or pages. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'SEVERABILITY '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'If any provision of this Agreement is found to be invalid or unenforceable, the remaining provisions shall be enforced to the fullest extent possible, and the remaining provisions of the Agreement shall remain in full force and effect. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'GENERAL PROVISIONS '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'This Agreement supersedes any previous Terms of Use Agreement to which you and Tusk Digital may have been bound. This Agreement will be binding on, inure to the benefit of, and be enforceable against the parties and their respective successors and assigns. Neither the course of conduct between parties nor trade practice shall act to modify any provision of the Agreement. All rights not expressly granted herein are hereby reserved. Headings are for reference purposes only and in no way define, limit, construe or describe the scope or extent of such section. '
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'CONTACTING US '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'If you have questions regarding the Agreement or the practices of Tusk Digital, please contact us by filling out the form ',
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/contact' },
	                    'here'
	                  )
	                )
	              ),
	              _react2.default.createElement(_footer2.default, null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return terms;
	}(_react.Component);
	
	exports.default = terms;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-of-use-js-1a1c63f41660bb230655.js